(function () {
    'use strict';

    angular
        .module('print')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('printGD', {
                url : '/print-GD/:blockId?,crewScheduleEventId?',
                params: {
                    blockId: null
                },
                views : {
                    'printGDView' : {
                        templateUrl : 'print-gd.tpl.html',
                        controller : 'PrintGDCtrl',
                        controllerAs : 'printGD'
                    }
                }
            })
            .state('printJourneyLog', {
                url : '/print-Journey-Log/:blockId?',
                params: {
                	blockId: null,
                	version: 0,
                	crewScheduleEventId:null
                },
                views : {
                    'printJourneyLogView' : {
                        templateUrl : 'print-journey-log.tpl.html',
                        controller : 'PrintJourneyLogCtrl',
                        controllerAs : 'PrintJourneyLog'
                    }
                }
            })
            .state('printDutySheet', {
                url : '/print-Duty-Sheet/:fromDateStr?,fromTimeStr?,toDateStr?,toTimeStr?,journeyLogNumberStr?,crewType?,airPortCode?,aircraftModel?,isDestinationOnly?,dutySheetHidePersonalDetailsEnabled?',
                params: {
                	fromDateStr: null,
                	fromTimeStr: null,
                	toDateStr: null,
                	toTimeStr:null,
                	journeyLogNumberStr:null,
                	crewType:null,
                	airPortCode:null,
                	aircraftModel:null,
                	getOtherGroundDuties:true,
                	isDestinationOnly :null,
                  dutySheetHidePersonalDetailsEnabled: null
                },
                views : {
                    'printDutySheetView' : {
                        templateUrl : 'print-duty-sheet.tpl.html',
                        controller : 'PrintDutySheetCtrl',
                        controllerAs : 'PrintDutySheet'
                    }
                }
            });
    }
}());
